import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/dateForm/styles.scss';export default {
  "form": "_form_o9gur_1",
  "attribute": "_attribute_o9gur_9"
};